module.exports = __webpack_public_path__ + "static/media/logo.c62c5b01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 381
// module chunks = 0